<template>
  <div>
    <div v-show="!showUpdate" class="app-content content ">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header row">
          <div class="content-header-left col-md-9 col-12 mb-2">
            <Breadcrumb
                name="Permissions"
                bc1="App"
                bc2="Permissions"
                bc3="List"
            ></Breadcrumb>
          </div>

        </div>
        <div class="content-body">
          <div class="card">
            <div class="m-2">
              <div class="row">
                <div class="col-sm-6 col-md-4">
                  <input class="form-control" @keyup.enter="onSubmitFilters" type="text" v-model="search" placeholder="Search here..."/>
                </div>
                <div class="col-sm-6 col-md-4 mt-50">
                  <button class="btn btn-sm btn-primary" @click="onSubmitFilters">Search</button>
                </div>
              </div>
            </div>
            <CommonTableStore
                :url="url"
                :tableHeaderValues="tableHeaderValues"
                :actions="actions"
                :deleteActions="deleteActions"
                :mutedData="mutedData"
                :storageKey="storageKey"
                :filteredData="filteredData"
                :externalTotalRecord="externalTotalRecord"
                :show-per-page="true"

            />
          </div>
        </div>
      </div>
      <DetailTextModal :show="showDescriptionModal" :text="description"
                       @hide="showDescriptionModal = false" />
    </div>
    <UpdatePermission @back="showUpdate = false" v-if="showUpdate" />
  </div>
</template>

<script>

import DetailTextModal from "@/components/common/modals/DetailTextModal";
import UpdatePermission from "@/pages/dashboard/permissions/updatePermission.vue";
export default {
  components: {DetailTextModal,UpdatePermission },

  mounted() {
    localStorage.setItem("url", "v1/get-permission");
    this.checkDataInStore('v1/get-permission')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      search:'',
      showUpdate:false,
      url: "v1/get-permission",
      storageKey: "permissions",
      filteredData:{onlyPermissions:1},
      description:'',
      showDescriptionModal:false,
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "description",
          html: true,
          alter: function(value, row) {
            var html = "N/A";
            if (value) {
              html = `<span class="badge badge-light-primary badge-sm">${value}</span>`;
            }



            return html;
          }
        },
        {
          title: "Endpoint",
          valueKey: "end_point",
          html: true,
          alter: function(value, row) {
            var html = "N/A";
            if (value) {
              html = `<span class="badge badge-light-warning badge-sm">${value}</span>`;
            }



            return html;
          }
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function(value, row) {
            var html = "";
            if (value == 1) {
              html = `<span class="badge badge-success badge-sm">Active</span>`;
            } else {
              html = `<span class="badge badge-danger badge-sm">Inactive</span>`;
            }

            // if (row.is_default == 1) {
            //   this.isDefault = true;
            //   html += '<span class="badge badge-secondary ml-1">Default</span>';
            // }

            return html;
          }
        },
        // {
        //   title: "Description",
        //   valueKey: "description",
        //   html: true,
        //   alter: function(value) {
        //     var html = "";
        //     if (value) {
        //       html = `<span class="text-danger" style="cursor: pointer" title="click to view full description">${value.substring(0,12)+'...'}</span>`;
        //       return html;
        //     } else {
        //       html = "-";
        //       return html;
        //     }
        //   },
        //   cta: (row) => {
        //     this.description = row.description
        //     this.showDescriptionModal = true
        //   }
        // },
      ],
      actions: [
        {
          title: "Update",
          class: "btn-primary",
          cta: (row, index) => {
            let data = {
              ...row,
              index: index,
              row: row,
              key: "permissionUpdate",
              storageKey: this.storageKey,
              idx: index,
            }
            this.$store.dispatch("set", data);
            this.showUpdate = true

          }
        },
      ],
      deleteActions: [
        // {
        //   title: "Delete",
        //   class: " ml-1 custom-control-primary",
        //   cta: (row, index) => {
        //     let data = {
        //       index: index,
        //       row: row,
        //       key: "permissionDelete"
        //     };
        //     this.deleteRecord(data);
        //   }
        // }
      ],
      mutedData: [],
      externalTotalRecord: ""
    };
  },
  methods: {
    onSubmitFilters() {

      let filterData = {onlyPermissions:1}

      if(this.search != ''){
        filterData.searchTerm = this.search
      }


      this.filteredData = filterData


    },
    deleteRecord(data) {
      this.makeRequest("post", "v1/update-permission-status", {
        status: data.row.status == true ? 1 : 0,
        id: data.row.id
      }).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let storeData = this.$store.getters.getByKey("permissions");
            if (storeData != null) {
              if (typeof storeData.firstPageData != "undefined") {
                if (
                  typeof storeData.firstPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.firstPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.firstPageData.data[data.index] = data.row;
                    delete storeData.otherPageData;
                  }
                }
              }
              if (typeof storeData.otherPageData != "undefined") {
                if (
                  typeof storeData.otherPageData.data[data.index] != "undefined"
                ) {
                  if (
                    storeData.otherPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.otherPageData.data[data.index] = data.row;
                  }
                }
              }
              storeData.key = "permissions";
              this.$store.dispatch("set", storeData);
            }
          }
        }
      });
    }
  }
};
</script>
